import React, { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  indeterminateColor: {
    color: '#f50057',
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  horizontalRule: {
    borderTop: '1px solid grey',
    margin: '0 10px',
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps: any = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 300,
    },
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
  variant: 'menu',
};

interface MultiSelectProps {
  options: string[];
  selected: string[];
  searchIn: 'rpFiles' | 'userJourney';
  handleChange: (searchIn: any, value: any) => void;
}
function MultiSelect({ options, searchIn, selected, handleChange }: MultiSelectProps) {
  const [selectedOption, setSelectedOption] = useState<string[]>(selected);
  const [selectedSearchIn, setSelectedSearchIn] = useState<'rpFiles' | 'userJourney'>('userJourney');
  const classes = useStyles();
  const style = { width: 200 };
  const isAllSelected = options.length > 0 && selected.length === options.length;

  return (
    <FormControl sx={style}>
      <InputLabel id="mutiple-select-label">Multiple Select</InputLabel>
      <Select
        variant="standard"
        labelId="mutiple-select-label"
        multiple
        value={selected}
        autoWidth
        onChange={(e: any) => {
          handleChange(selectedSearchIn, e.target.value);
          setSelectedOption(e.target.value);
        }}
        renderValue={(selected: any) => {
          if (selected.length === 1) return selected;
          if (selected.length === options.length) return 'All Options selected';
          else return selected.length + ' Options selected';
        }}
        MenuProps={MenuProps}
      >
        <RadioGroup
          sx={{ marginLeft: 3 }}
          aria-labelledby="demo-radio-buttons-group-label"
          name="radio-buttons-group"
          defaultValue={searchIn}
          onChange={(e: any) => {
            handleChange(e.target.value, selectedOption);
            setSelectedSearchIn(e.target.value);
          }}
        >
          <FormControlLabel value="rpFiles" disabled={true} control={<Radio />} label="All RP Files" />
          <FormControlLabel value="userJourney" disabled={true} control={<Radio />} label="Entire UserJourney" />
        </RadioGroup>
        <div className={classes.horizontalRule}></div>
        <MenuItem
          value="all"
          classes={{
            root: isAllSelected ? classes.selectedAll : '',
          }}
        >
          <ListItemIcon>
            <Checkbox
              classes={{ indeterminate: classes.indeterminateColor }}
              checked={isAllSelected}
              indeterminate={selected.length > 0 && selected.length < options.length}
            />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.selectAllText }} primary="Select All" />
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            <ListItemIcon>
              <Checkbox checked={selected.indexOf(option || '') > -1} />
            </ListItemIcon>
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MultiSelect;
